import React from 'react'
import styled from 'styled-components'
import { Grid as BaseGrid, Hidden as BaseHidden } from '@material-ui/core'

export const Root = styled.div`
  margin: 0;
  padding: 0 0 130px;
  width: 100%;
`

export const Actions = styled.div`
  margin-top: 28px;
`

export const CodeLabel = styled.label`
  color: ${props => props.theme.palette.brand.black3};
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1.125px;
  line-height: 14px;
  margin: 0 0 0.5rem;
  text-transform: uppercase;
`

export const EmailSection = styled.div`
  margin-top: 15px;
`

export const Image = styled.img`
  width: 100%;
  ${props => props.theme.breakpoints.down('xs')} {
    max-width: 140px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
`

export const Information = styled.div`
  color: ${props => props.theme.palette.brand.black3};
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 22px;

  ${props => props.theme.breakpoints.down('xs')} {
    padding-left: 40px;
    padding-right: 40px;
    text-align: center;
    display: block;
  }
`

export const DesktopNavigation = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 30px;
  margin: 0;
  width: 100%;
`

export const MobileNavigation = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.custom.ghostWhite};
  bottom: 0;
  box-shadow: 0 -3px 10px ${props => props.theme.palette.custom.ghostBlack};
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 32px;
  height: 90px;
  justify-content: center;
  left: 0;
  position: fixed;
  width: 100%;
`

export const Instructions = styled.p`
  margin-top: 28px;
  font-size: 22px;
  line-height: 26px;
  font-weight: 300;
  margin-bottom: 20px;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const Label = styled.label`
  color: ${props => props.theme.palette.brand.black3};
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  margin: 20px 0 2rem;
`

export const Title = styled.h1`
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 34px;
  font-weight: 300;
  line-height: 45px;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const Section = styled(({ margin, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth || 'initial'};
  padding: ${props => props.padding || 'initial'};
  text-align: left;
`

export const SpinnerRoot = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`

export const Strong = styled.span`
  font-weight: bold;
`

export const Hidden = styled(BaseHidden)``
